import React from 'react'

import PropTypes from 'prop-types'

import { VFButton, Shimmer } from '@vfgroup-oneplatform/foundation/Components'

import { loadingConfig, shimmerPlaceholderConfig } from './BookAppointmentButton.LoadingConfig'
import styles from './BookAppointmentButton.Styles'

const BookAppointmentButton = ({
  isLoading,
  onBookAppointmentsButtonPress,
  title
}) => {

  if (isLoading) {
    return <Shimmer
      config={loadingConfig}
      shimmerPlaceholderConfig={shimmerPlaceholderConfig}
    />
  }
  return (
    <VFButton
      style={styles.contaier}
      title={title ? title : 'your_appointments_book_button'}
      onPress={onBookAppointmentsButtonPress}
    />
  )
}
BookAppointmentButton.propTypes = {
  isLoading: PropTypes.bool,
  onBookAppointmentsButtonPress: PropTypes.func,
  title: PropTypes.string
}
export default BookAppointmentButton
